/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-08T21:12:24.392
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getFollowBillEditInit,
	getFollowBillView
} from '@api/storagemanage/FollowBill';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getFollowBillEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFollowBillEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFollowBillView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFollowBillView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
